import type { Platform } from '../CharacterTypes';

/**
 * Where an authored teleporter platform leads. Shared (lane AK, 2026-10-08)
 * so the server's portal authority (world-transfer/PortalTransferPolicy), the
 * guest story-map gate and the client World Map read one routing rule; it moved
 * here verbatim from PortalTransferPolicy.
 */
export interface AuthorizedPortalRoute {
  sourcePortalId: string;
  destinationMapId: string;
  destinationSpawnId?: string;
}

/** The destination an authored teleporter platform routes to. */
export function routeForPlatform(platform: Platform, sourceMapId: string): AuthorizedPortalRoute {
  const row = platform as Platform & {
    targetMapId?: string;
    targetSpawnId?: string;
    teleporterLink?: { targetMapId?: string; targetId?: string };
  };
  const editorLink = row.properties?.teleporterLink ?? row.teleporterLink;
  const config = row.teleporterConfig ?? {};
  const destinationMapId = config.targetMapId
    ?? editorLink?.targetMapId
    ?? row.targetMapId
    ?? sourceMapId;
  const destinationSpawnId = editorLink?.targetId
    ?? config.targetSpawnId
    ?? row.targetSpawnId
    ?? (row.attributes?.type === 'exp_shrine' ? undefined : `${row.id}_dest`);
  return {
    sourcePortalId: row.id,
    destinationMapId,
    ...(destinationSpawnId ? { destinationSpawnId } : {}),
  };
}
